import { TR_TUTORIAL_DESCRIPTION_LONG_TAP, TR_TUTORIAL_DESCRIPTION_PANNING, TR_TUTORIAL_DESCRIPTION_PINCH, TR_TUTORIAL_DESCRIPTION_ROTATE, TR_TUTORIAL_DESCRIPTION_TOUCH_LONG_TAP, TR_TUTORIAL_DESCRIPTION_TOUCH_PANNING, TR_TUTORIAL_DESCRIPTION_TOUCH_PINCH, TR_TUTORIAL_DESCRIPTION_TOUCH_ROTATE, TR_TUTORIAL_STEP_TITLE_LONG_TAP, TR_TUTORIAL_STEP_TITLE_PANNING, TR_TUTORIAL_STEP_TITLE_PINCH, TR_TUTORIAL_STEP_TITLE_ROTATE, } from '@/constants';
const longTapStep = {
    step: TR_TUTORIAL_STEP_TITLE_LONG_TAP,
    description: TR_TUTORIAL_DESCRIPTION_LONG_TAP,
    touchDescription: TR_TUTORIAL_DESCRIPTION_TOUCH_LONG_TAP,
    animation: 'camera-tutorial-focus',
};
const panningStep = {
    step: TR_TUTORIAL_STEP_TITLE_PANNING,
    description: TR_TUTORIAL_DESCRIPTION_PANNING,
    touchDescription: TR_TUTORIAL_DESCRIPTION_TOUCH_PANNING,
    animation: 'camera-pan',
    gestures: ['pan', 'dolly-pan'],
};
const pinchStep = {
    step: TR_TUTORIAL_STEP_TITLE_PINCH,
    description: TR_TUTORIAL_DESCRIPTION_PINCH,
    touchDescription: TR_TUTORIAL_DESCRIPTION_TOUCH_PINCH,
    animation: 'camera-dolly',
    gestures: ['dolly', 'dolly-pan', 'dolly-rotate'],
};
const rotateStep = {
    step: TR_TUTORIAL_STEP_TITLE_ROTATE,
    description: TR_TUTORIAL_DESCRIPTION_ROTATE,
    touchDescription: TR_TUTORIAL_DESCRIPTION_TOUCH_ROTATE,
    animation: 'camera-rotate',
    gestures: ['rotate', 'dolly-rotate'],
};
export const TUTORIAL_STEPS = [pinchStep, panningStep, rotateStep, longTapStep];
export const TUTORIAL_STEP_DURATION = 10 * 1000; // 10 seconds
export const TUTORIAL_CONTINUOUS_INTERACTION_TIME = 500;
